import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-page',
  templateUrl: './ai-page.component.html',
  styleUrl: './ai-page.component.scss',
  standalone: false,
})
export class AiPageComponent {}
